import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const lpaFrontlineQuestionsState = atom({
  key: 'lpaFrontlineQuestionsState',
  default: {
    LPAQuestions: [],
  },
  effects_UNSTABLE: [persistAtom],
});

